import SignAContract from "@src/pages/signAContract";
import CreditInvestigation from "@src/pages/CreditInvestigation";
export default {}

export const ROUTE_ROOT_URI = "/emosolution"

// 项目key
export const sessionKey = 'config_data_cfmoto'
// 联系电话
export const SERVICE_PHONE = '4009155011'

export const BASIC_AUTH = 'Basic Y29uc29sZTpzZWNyZXQ='

// 春风 cfmoto EV zeeho KTM ktm 宗审
type SOURCETYPE = 'cfmoto' | 'zeeho' | 'ktm' | 'zsmoto'
export const SOURCE:SOURCETYPE = 'zeeho'
export const brandName = 'ZeehoApp'
// 春风 1 宗审 2 ktm 3 ev 4
export const vehicleBrand = '4'

export const RefuseReason = {
  "00": "您的身份证填写错误",
  "01": "手机号填写错误",
  "02": "身份证二要素对比有误",
  "10": "关联法院不良信息",
  "11": "银行或大数据资信不良",
  "20": "无稳定工作",
  "21": "综合评分不足",
  "22": "单位状态异常",
  "23": "单位状态异常",
  "24": "您的年龄暂不符合申请要求",
  "25": "单位状态异常",
  "26": "银行或大数据资信不良",
  "27": "银行或大数据资信不良",
  "28": "银行或大数据资信不良",
  "29": "虚拟号码/物联⽹卡/上⽹卡等不可进件",
  "30": "单位类型不可进件"
}

export const ORDER_STATUS = {
  "0": '待申请',
  "1": '审核中',
  "2": '已通过',
  "3": '放款中',
  "4": '已放款',
  "5": '已拒绝',
  "88": '已过期',
}
/**
 * 不需要进行用户登录验证的路由
 */
 export const ignoreAuthPaths: Array<{ path: string, component: any }> = [{
	path: `${ROUTE_ROOT_URI}/sA`,
	component: SignAContract
},{
	path: `${ROUTE_ROOT_URI}/cI`,
	component: CreditInvestigation
}]